import { lazy } from "react";
import { Landmark } from "lucide-react";
import type { AdminModule } from "../types";

const Collectors = lazy(() => import("./pages/Collectors").then((m) => ({ default: m.Collectors })));
const Disputes = lazy(() => import("./pages/Disputes").then((m) => ({ default: m.Disputes })));
const Payouts = lazy(() => import("./pages/Payouts").then((m) => ({ default: m.Payouts })));
const Events = lazy(() => import("./pages/Events").then((m) => ({ default: m.Events })));

/**
 * RFC-850 — card collection across businesses, and running NuForce Pay:
 * who collects through what, the disputes NuForce must answer, payouts, and
 * the provider event log.
 */
export const paymentsModule: AdminModule = {
  key: "payments",
  label: "Payments",
  description: "Card collection across businesses: collectors, disputes, payouts and provider events.",
  group: "revenue",
  icon: Landmark,
  routes: [
    { path: "collectors", label: "Collectors", element: <Collectors />, requiredPermission: "admin.payments.read" },
    { path: "disputes", label: "Disputes", element: <Disputes />, requiredPermission: "admin.payments.read" },
    { path: "payouts", label: "Payouts", element: <Payouts />, requiredPermission: "admin.payments.read" },
    { path: "events", label: "Provider events", element: <Events />, requiredPermission: "admin.payments.read" },
  ],
};
